import * as types from "./GroupOrdersTypes";

// Create Group Order
const createGroupOrderInitial = { data: null, loading: false, error: null, success: false };
export const createGroupOrderReducer = (state = createGroupOrderInitial, action) => {
  switch (action.type) {
    case types.CREATE_GROUP_ORDER_RESET:
      return createGroupOrderInitial;
    case types.CREATE_GROUP_ORDER_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CREATE_GROUP_ORDER_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.CREATE_GROUP_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Fetch Group Orders (admin list)
const fetchGroupOrdersInitial = { data: [], loading: false, error: null };
export const fetchGroupOrdersReducer = (state = fetchGroupOrdersInitial, action) => {
  switch (action.type) {
    case types.FETCH_GROUP_ORDERS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_GROUP_ORDERS_SUCCESS:
      return { data: action.payload, loading: false, error: null };
    case types.FETCH_GROUP_ORDERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Fetch Group Order Details (admin single)
const fetchGroupOrderDetailsInitial = { data: null, loading: false, error: null };
export const fetchGroupOrderDetailsReducer = (state = fetchGroupOrderDetailsInitial, action) => {
  switch (action.type) {
    case types.FETCH_GROUP_ORDER_DETAILS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_GROUP_ORDER_DETAILS_SUCCESS:
      return { data: action.payload, loading: false, error: null };
    case types.FETCH_GROUP_ORDER_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Fetch Group Order (public)
const fetchGroupOrderInitial = { data: null, loading: false, error: null };
export const fetchGroupOrderReducer = (state = fetchGroupOrderInitial, action) => {
  switch (action.type) {
    case types.FETCH_GROUP_ORDER_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_GROUP_ORDER_SUCCESS:
      return { data: action.payload, loading: false, error: null };
    case types.FETCH_GROUP_ORDER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create Group Payment (public)
const createGroupPaymentInitial = { data: null, loading: false, error: null };
export const createGroupPaymentReducer = (state = createGroupPaymentInitial, action) => {
  switch (action.type) {
    case types.CREATE_GROUP_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.CREATE_GROUP_PAYMENT_SUCCESS:
      return { data: action.payload, loading: false, error: null };
    case types.CREATE_GROUP_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Confirm Group Payment (public)
const confirmGroupPaymentInitial = { data: null, loading: false, error: null, success: false };
export const confirmGroupPaymentReducer = (state = confirmGroupPaymentInitial, action) => {
  switch (action.type) {
    case types.CONFIRM_GROUP_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CONFIRM_GROUP_PAYMENT_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.CONFIRM_GROUP_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Fetch My Group Orders (coordinator)
const fetchMyGroupOrdersInitial = { data: [], loading: false, error: null };
export const fetchMyGroupOrdersReducer = (state = fetchMyGroupOrdersInitial, action) => {
  switch (action.type) {
    case types.FETCH_MY_GROUP_ORDERS_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_MY_GROUP_ORDERS_SUCCESS:
      return { data: action.payload, loading: false, error: null };
    case types.FETCH_MY_GROUP_ORDERS_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Redeem Group Code (student)
const redeemGroupCodeInitial = { data: null, loading: false, error: null, success: false };
export const redeemGroupCodeReducer = (state = redeemGroupCodeInitial, action) => {
  switch (action.type) {
    case types.REDEEM_GROUP_CODE_RESET:
      return redeemGroupCodeInitial;
    case types.REDEEM_GROUP_CODE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.REDEEM_GROUP_CODE_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.REDEEM_GROUP_CODE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Validate Group Code (public)
const validateGroupCodeInitial = { data: null, loading: false, error: null };
export const validateGroupCodeReducer = (state = validateGroupCodeInitial, action) => {
  switch (action.type) {
    case types.VALIDATE_GROUP_CODE_RESET:
      return validateGroupCodeInitial;
    case types.VALIDATE_GROUP_CODE_REQUEST:
      return { ...state, loading: true, error: null };
    case types.VALIDATE_GROUP_CODE_SUCCESS:
      return { data: action.payload, loading: false, error: null };
    case types.VALIDATE_GROUP_CODE_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create Individual Code Payment (authenticated)
const createIndividualCodePaymentInitial = { data: null, loading: false, error: null, success: false };
export const createIndividualCodePaymentReducer = (state = createIndividualCodePaymentInitial, action) => {
  switch (action.type) {
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_RESET:
      return createIndividualCodePaymentInitial;
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Confirm Individual Code Payment (authenticated)
const confirmIndividualCodePaymentInitial = { data: null, loading: false, error: null, success: false };
export const confirmIndividualCodePaymentReducer = (state = confirmIndividualCodePaymentInitial, action) => {
  switch (action.type) {
    case types.CONFIRM_INDIVIDUAL_CODE_PAYMENT_RESET:
      return confirmIndividualCodePaymentInitial;
    case types.CONFIRM_INDIVIDUAL_CODE_PAYMENT_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CONFIRM_INDIVIDUAL_CODE_PAYMENT_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.CONFIRM_INDIVIDUAL_CODE_PAYMENT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Create Individual Code Payment Public (registration)
const createIndividualCodePaymentPublicInitial = { data: null, loading: false, error: null, success: false };
export const createIndividualCodePaymentPublicReducer = (state = createIndividualCodePaymentPublicInitial, action) => {
  switch (action.type) {
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_RESET:
      return createIndividualCodePaymentPublicInitial;
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.CREATE_INDIVIDUAL_CODE_PAYMENT_PUBLIC_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Activate Group Order Paid Codes (admin)
const activatePaidCodesInitial = { data: null, loading: false, error: null, success: false };
export const activatePaidCodesReducer = (state = activatePaidCodesInitial, action) => {
  switch (action.type) {
    case types.ACTIVATE_PAID_CODES_RESET:
      return activatePaidCodesInitial;
    case types.ACTIVATE_PAID_CODES_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.ACTIVATE_PAID_CODES_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.ACTIVATE_PAID_CODES_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Approve Group Order Request (admin)
const approveGroupOrderRequestInitial = { data: null, loading: false, error: null, success: false };
export const approveGroupOrderRequestReducer = (state = approveGroupOrderRequestInitial, action) => {
  switch (action.type) {
    case types.APPROVE_GROUP_ORDER_REQUEST_RESET:
      return approveGroupOrderRequestInitial;
    case types.APPROVE_GROUP_ORDER_REQUEST_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.APPROVE_GROUP_ORDER_REQUEST_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.APPROVE_GROUP_ORDER_REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

// Reject Group Order Request (admin)
const rejectGroupOrderRequestInitial = { data: null, loading: false, error: null, success: false };
export const rejectGroupOrderRequestReducer = (state = rejectGroupOrderRequestInitial, action) => {
  switch (action.type) {
    case types.REJECT_GROUP_ORDER_REQUEST_RESET:
      return rejectGroupOrderRequestInitial;
    case types.REJECT_GROUP_ORDER_REQUEST_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case types.REJECT_GROUP_ORDER_REQUEST_SUCCESS:
      return { data: action.payload, loading: false, error: null, success: true };
    case types.REJECT_GROUP_ORDER_REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
